<section class="astral-contract-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (dataContext) {
    @if (dataContext.isNew) {
      <ng-container *ngTemplateOutlet="newContractLayout"></ng-container>
    } @else {
      <astral-form [form]="form" [columns]="4" (formSubmit)="onSubmit()">
        <section class="astral-grid-full astral-section-surface">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
            <astral-input [control]="form.controls['popularName']"></astral-input>
            <astral-select [control]="form.controls['subCategory']" [itemsSource]="subCategories"></astral-select>
            <astral-input
              label="LEASE_AGREEMENT.STATUS"
              [value]="dataContext.statusCaption | translate"
              [readonly]="true"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.STATUS'"
            ></astral-input>
          </astral-layout-group>
        </section>
      </astral-form>
      <div class="astral-content-width astral-accordion-stack">
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.RENTAL_OBJECT'">
          <div class="astral-stack-l">
            @for (objectForm of $any(rentalObjectForms.controls); track objectForm; let i = $index) {
              <div class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-form-stack">
                <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                  <astral-select [control]="objectForm.controls['category']" [itemsSource]="categories"></astral-select>
                  <astral-select
                    class="astral-grid-desktop-span-2"
                    [control]="objectForm.controls['rentalObjectId']"
                    [itemsSource]="getObjectSelection(objectForm)"
                    [noOptionsPlaceholderText]="'COMMON.NO_OPTIONS_AVAILABLE'"
                    [disableWhenNoOptions]="true"
                  ></astral-select>
                  @if (rentalObjectForms.controls.length > 1) {
                    <div class="astral-delete-action astral-form-adjacent-action">
                      <astral-button
                        variant="secondary"
                        type="button"
                        icon="trash"
                        labelKey="DELETE_BTN"
                        (click)="removeRentalObject(i)"
                      ></astral-button>
                    </div>
                  }
                </astral-layout-group>
                @if (objectForm.controls['rentalObjectId'].value) {
                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                    <astral-date-picker [control]="objectForm.controls['fromDate']"></astral-date-picker>
                    <astral-date-picker [control]="objectForm.controls['toDate']"></astral-date-picker>
                    <div class="astral-link-action astral-form-adjacent-action">
                      <astral-button
                        variant="link-button"
                        type="button"
                        labelKey="COMMON.OPEN_RENTAL_OBJECT"
                        (click)="onRentalObjectClicked(objectForm)"
                      ></astral-button>
                    </div>
                  </astral-layout-group>
                }
              </div>
            }
            <div class="astral-layout-item">
              <astral-button variant="primary" type="button" icon="plus" labelKey="ADD_BTN" (click)="addRentalObject()"></astral-button>
            </div>
            <astral-input class="astral-grid-full" [control]="form.controls['usage']"></astral-input>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
              <astral-input [control]="form.controls['rentalObjectSumSurface']" [type]="'number'"></astral-input>
              <astral-input [control]="form.controls['leaseAgreementArea']" [type]="'number'"></astral-input>
            </astral-layout-group>
          </div>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.TENANT_NAME'" [allowWidthExpansion]="true">
          <div class="astral-stack-l">
            <div class="astral-content-width">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                <div class="astral-grid-full">
                  <app-tenant-select
                    [dataContext]="dataContext"
                    [tenantCount]="1"
                    [form]="form"
                    (tenantOneChange)="onTenantOneChange($event)"
                  ></app-tenant-select>
                </div>
              </astral-layout-group>
            </div>
            @if (dataContext.hasOtherLeaseAgreements) {
              <div class="astral-grid-full astral-stack-l">
                <p class="help-text">{{ 'LEASE_AGREEMENT.HELP_TEXT.OTHER_LEASE_AGREEMENTS' | translate }}</p>
                <app-list-view
                  [columnDefinition]="otherLeaseAgreementColumnDefinition"
                  [itemsSource]="dataContext.otherLeaseAgreements"
                  [preferencesKey]="'rent.block-contract.other-lease-agreements'"
                  (rowClick)="onOtherLeaseAgreementClicked($event)"
                ></app-list-view>
              </div>
            }
          </div>
        </astral-accordion>
        @if (form) {
          <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HEADER'">
            <div class="astral-stack-l">
              <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
                <astral-date-picker
                  [control]="form.controls['agreementDate']"
                  [model]="dataContext.agreementDate"
                  [label]="'LEASE_AGREEMENT.AGREEMENT_DATE'"
                  [isRequired]="true"
                ></astral-date-picker>
              </astral-layout-group>
              <div class="astral-grid-full">
                <app-notice-period
                  [form]="form.controls['noticePeriod']"
                  [dataContext]="dataContext"
                  (fromChange)="onNoticePeriodFromChanged($event)"
                ></app-notice-period>
              </div>
            </div>
          </astral-accordion>
        }
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT_ROW.LIST_HEADER'">
          <div class="astral-stack-l">
            <div class="astral-grid-full">
              <app-block-lease-rows
                [form]="form"
                [currency]="dataContext.currencyCode"
                [leaseStartDate]="fromDate"
                [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
                [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
                [currentPeriodText]="dataContext.currentPeriodText"
                [rentalObjectSize]="rentalObjectSurface"
                [leaseAgreementInvoicePeriod]="dataContext.invoicePeriod"
                [rentalObjectSelection]="rentalObjectSelection"
                [cultureName]="dataContext.cultureName"
                [itemsSource]="leaseAgreementRows"
                [entityId]="dataContext.id"
                [contractService]="dataService"
                (itemSourceChange)="onItemSourceChange($event)"
                (leaseRowsChange)="onLeaseRowsChange($event)"
              ></app-block-lease-rows>
            </div>
            <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
              <app-money-box [control]="form.controls['originalContractualRent']"></app-money-box>
            </astral-layout-group>
            <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
              <astral-select [control]="form.controls['rentPayment']" [itemsSource]="rentPayments"></astral-select>
            </astral-layout-group>
            @if (!isRentPaymentCustomOrTotal) {
              <astral-layout-group
                [columns]="4"
                [tabletColumns]="2"
                [mobileColumns]="1"
                [span]="'full'"
                >
                <astral-select
                  [control]="form.controls['householdElectricityPayment']"
                  [itemsSource]="householdElectricityPayments"
                ></astral-select>
                <astral-select
                  [control]="form.controls['parkingElectricityPayment']"
                  [itemsSource]="parkingElectricityPayments"
                ></astral-select>
                <astral-select [control]="form.controls['heatingPayment']" [itemsSource]="heatingPayments"></astral-select>
                <astral-select [control]="form.controls['coldWaterPayment']" [itemsSource]="coldWaterPayments"></astral-select>
                <astral-select [control]="form.controls['hotWaterPayment']" [itemsSource]="hotWaterPayments"></astral-select>
              </astral-layout-group>
            }
            @if (isRentPaymentCustom) {
              <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
                <astral-textarea
                  [control]="form.controls['rentPaymentTerms']"
                  [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENT_PAYMENT_TERMS'"
                ></astral-textarea>
              </astral-layout-group>
            }
          </div>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.INVOICING_HEADER'">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <div class="astral-grid-full">
              <app-contract-invoicing
                [form]="form"
                [dataContext]="dataContext"
                [tenantOne]="tenantOne"
                [addressForm]="form.controls['invoiceAddress']"
                [category]="dataContext.category"
                [company]="dataContext.company"
              ></app-contract-invoicing>
            </div>
            <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER' | translate }}</h4>
            <astral-toggle
              [control]="form.controls['individualInvoiceAddress']"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INDIVIDUAL_INVOICE_ADDRESS'"
            ></astral-toggle>
            <h6 class="astral-grid-full">{{ individualAddressMessage | translate }}</h6>
            <div class="astral-grid-full">
              <app-postal-address
                [group]="form.controls['invoiceAddress']"
                [model]="invoiceAddress"
                [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
                [showName]="true"
                [mandatory]="true"
                [title]="''"
              ></app-postal-address>
            </div>
          </astral-layout-group>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.TERMS'">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-textarea class="astral-grid-full" [control]="form.controls['specialTerms']"></astral-textarea>
          </astral-layout-group>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.SECURITY_HEADER'" [indicator]="hasSecurity">
          <div class="astral-layout-item">
            <app-contract-security [form]="form" [dataContext]="dataContext"></app-contract-security>
          </div>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'REPRESENTATIVE.BLOCK_NAME'" [counter]="dataContext.representatives.length">
          <div class="astral-layout-item">
            <app-representative-manager [dataContext]="dataContext" [form]="form"></app-representative-manager>
          </div>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'COMMON.NOTE'" [indicator]="!!dataContext.note">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-textarea class="astral-grid-full" [control]="form.controls['note']"></astral-textarea>
          </astral-layout-group>
        </astral-accordion>
        @if (dataContext.fastighetsagarnaDokumentActive) {
          <astral-accordion
            class="astral-grid-full"
            [header]="'FASTIGHETSAGARNA_DOKUMENT.FASTIGHETSAGARNA_DOKUMENT'"
            [helpText]="'FASTIGHETSAGARNA_DOKUMENT.HELP_TEXT.ACCORDION_HEADER'"
            >
            <div class="astral-layout-item">
              <app-form-cases-fastighetsagarna-dokument
                [form]="form"
                [itemsSource]="dataContext.leaseAgreementForms"
                [leaseAgreementId]="dataContext.id"
                [leaseAgreementCategory]="1"
              ></app-form-cases-fastighetsagarna-dokument>
            </div>
          </astral-accordion>
        }
        @if (form) {
          <astral-accordion class="astral-grid-full" [header]="'CONSUMPTION.CONSUMPTION'" (stateChanged)="allowSectionInit('imdConsumption')" [allowWidthExpansion]="true">
            <div class="astral-layout-item">
              <app-information-block [text]="'CONSUMPTION.CONSUMPTION_LEASE_AGREEMENT_DESCRIPTION' | translate"></app-information-block>
            </div>
            @if (isSectionAllowed('imdConsumption')) {
              <div class="astral-layout-item wrap-rows">
                <app-list-view
                  [columnDefinition]="imdConsumptionColumnDefinition"
                  [itemsSource]="imdConsumption"
                  [preferencesKey]="'rent.block-contract.imd-consumption'"
                ></app-list-view>
              </div>
            }
          </astral-accordion>
        }
        <astral-accordion
          class="astral-grid-full"
          [header]="'FAULT_NOTIFICATION.EDIT_HEADER'"
          [helpText]="'FAULT_NOTIFICATION.HELP_TEXT.LEASE_AGREEMENT_INFORMATION'"
          [allowWidthExpansion]="true">
          <div class="astral-layout-item">
            <app-list-view
              [columnDefinition]="faultNotificationColumnDefinition"
              [itemsSource]="dataContext.faultNotifications"
              [preferencesKey]="'rent.block-contract.fault-notifications'"
              (rowClick)="onFaultNotificationRowClicked($event)"
            ></app-list-view>
          </div>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'DOCUMENT.DOCUMENTS'" [counter]="leaseAgreementDocumentCount" [fragment]="documentsFragment">
          <div class="astral-stack-l">
            <div class="astral-layout-item">
              <astral-button
                variant="primary"
                type="button"
                labelKey="LEASE_AGREEMENT.COMMAND.LINK_DOCUMENT"
                icon="plus"
                (click)="linkDocument()"
              ></astral-button>
            </div>
            <div class="astral-layout-item">
              <app-lease-agreement-document-manager
                [leaseAgreementId]="dataContext?.id"
                (countChange)="onDocumentsCountChanged($event)"
              ></app-lease-agreement-document-manager>
            </div>
          </div>
        </astral-accordion>
        @if (form) {
          <astral-accordion class="astral-grid-full" [header]="'LOG.HEADER'" (stateChanged)="allowSectionInit('logs')" [allowWidthExpansion]="true">
            @if (isSectionAllowed('logs')) {
              <div class="astral-layout-item wrap-rows">
                <app-list-view
                  [columnDefinition]="logColumnDefinition"
                  [itemsSource]="logs"
                  [preferencesKey]="'rent.block-contract.logs'"
                ></app-list-view>
              </div>
            }
          </astral-accordion>
        }
      </div>
    }
  }


  <ng-template #newContractLayout>
    <div class="astral-content-width astral-surface-stack">
      <app-information-block [text]="'LEASE_AGREEMENT.INFORMATION_TEXT.NEW_LEASE_AGREEMENT' | translate"></app-information-block>
      <astral-form [form]="form" [columns]="4" (formSubmit)="onSubmit()">
      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
          <astral-select [control]="form.controls['subCategory']" [itemsSource]="subCategories"></astral-select>
          <astral-input [control]="form.controls['popularName']"></astral-input>
          <astral-input [control]="form.controls['leaseAgreementArea']" [type]="'number'"></astral-input>
          <astral-input class="astral-grid-full" [control]="form.controls['usage']"></astral-input>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.RENTAL_OBJECT' | translate }}</h4>

          @if (companySelection) {
            <astral-select [control]="filterForm.controls['companyId']" [itemsSource]="companySelection"></astral-select>
          }
          @if (propertySelection) {
            <astral-select
              [control]="filterForm.controls['propertyId']"
              [itemsSource]="propertySelection"
              [noOptionsPlaceholderText]="'COMMON.NO_OPTIONS_AVAILABLE'"
              [disableWhenNoOptions]="true"
            ></astral-select>
          }

          <div class="astral-grid-full astral-stack-l">
            @for (objectForm of $any(rentalObjectForms.controls); track objectForm; let i = $index) {
              <div class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-form-stack">
                <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                  <astral-select [control]="objectForm.controls['category']" [itemsSource]="categories"></astral-select>
                  <astral-select
                    class="astral-grid-desktop-span-2"
                    [control]="objectForm.controls['rentalObjectId']"
                    [itemsSource]="getObjectSelection(objectForm)"
                    [noOptionsPlaceholderText]="'COMMON.NO_OPTIONS_AVAILABLE'"
                    [disableWhenNoOptions]="true"
                  ></astral-select>

                  @if (rentalObjectForms.controls.length > 1) {
                    <div class="astral-delete-action astral-form-adjacent-action">
                      <astral-button
                        variant="secondary"
                        type="button"
                        icon="trash"
                        labelKey="DELETE_BTN"
                        (click)="removeRentalObject(i)"
                      ></astral-button>
                    </div>
                  }
                </astral-layout-group>

                @if (objectForm.controls['rentalObjectId'].value) {
                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                    <astral-date-picker [control]="objectForm.controls['fromDate']"></astral-date-picker>
                    <astral-date-picker [control]="objectForm.controls['toDate']"></astral-date-picker>
                    <div class="astral-link-action astral-form-adjacent-action">
                      <astral-button
                        variant="link-button"
                        type="button"
                        labelKey="COMMON.OPEN_RENTAL_OBJECT"
                        (click)="onRentalObjectClicked(objectForm)"
                      ></astral-button>
                    </div>
                  </astral-layout-group>
                }
              </div>
            }

            <div class="astral-layout-item">
              <astral-button variant="primary" type="button" icon="plus" labelKey="ADD_BTN" (click)="addRentalObject()"></astral-button>
            </div>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.CONTRACT_HOLDER' | translate }}</h4>
          <div class="astral-grid-full">
            <app-tenant-select
              [dataContext]="dataContext"
              [tenantCount]="1"
              [form]="form"
              (tenantOneChange)="onTenantOneChange($event)"
            ></app-tenant-select>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HEADER' | translate }}</h4>
          <astral-date-picker
            [control]="form.controls['agreementDate']"
            [model]="dataContext.agreementDate"
            [label]="'LEASE_AGREEMENT.AGREEMENT_DATE'"
            [isRequired]="true"
          ></astral-date-picker>
          <div class="astral-grid-full">
            <app-notice-period
              [form]="form.controls['noticePeriod']"
              [dataContext]="dataContext"
              (fromChange)="onNoticePeriodFromChanged($event)"
            ></app-notice-period>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <div class="astral-grid-full">
            <app-block-lease-rows
              [form]="form"
              [currency]="dataContext.currencyCode"
              [leaseStartDate]="fromDate"
              [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
              [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
              [currentPeriodText]="dataContext.currentPeriodText"
              [rentalObjectSize]="rentalObjectSurface"
              [leaseAgreementInvoicePeriod]="dataContext.invoicePeriod"
              [rentalObjectSelection]="rentalObjectSelection"
              [cultureName]="dataContext.cultureName"
              [itemsSource]="leaseAgreementRows"
              [entityId]="dataContext.id"
              [contractService]="dataService"
              (itemSourceChange)="onItemSourceChange($event)"
              (leaseRowsChange)="onLeaseRowsChange($event)"
            ></app-block-lease-rows>
          </div>
          <app-money-box [control]="form.controls['originalContractualRent']"></app-money-box>
          <astral-select [control]="form.controls['rentPayment']" [itemsSource]="rentPayments"></astral-select>
          @if (!isRentPaymentCustomOrTotal) {
            <astral-select
              [control]="form.controls['householdElectricityPayment']"
              [itemsSource]="householdElectricityPayments"
            ></astral-select>
          }
          @if (!isRentPaymentCustomOrTotal) {
            <astral-select
              [control]="form.controls['parkingElectricityPayment']"
              [itemsSource]="parkingElectricityPayments"
            ></astral-select>
          }
          @if (!isRentPaymentCustomOrTotal) {
            <astral-select
              [control]="form.controls['heatingPayment']"
              [itemsSource]="heatingPayments"
            ></astral-select>
          }
          @if (!isRentPaymentCustomOrTotal) {
            <astral-select
              [control]="form.controls['coldWaterPayment']"
              [itemsSource]="coldWaterPayments"
            ></astral-select>
          }
          @if (!isRentPaymentCustomOrTotal) {
            <astral-select
              [control]="form.controls['hotWaterPayment']"
              [itemsSource]="hotWaterPayments"
            ></astral-select>
          }
          @if (isRentPaymentCustom) {
            <astral-textarea
              class="astral-grid-full"
              [control]="form.controls['rentPaymentTerms']"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENT_PAYMENT_TERMS'"
            ></astral-textarea>
          }
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.INVOICING_HEADER' | translate }}</h4>
          <div class="astral-grid-full">
            <app-contract-invoicing
              [form]="form"
              [dataContext]="dataContext"
              [addressForm]="form.controls['invoiceAddress']"
              [tenantOne]="tenantOne"
              [category]="dataContext.category"
              [company]="dataContext.company"
            ></app-contract-invoicing>
          </div>
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER' | translate }}</h4>
          <astral-toggle
            [control]="form.controls['individualInvoiceAddress']"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INDIVIDUAL_INVOICE_ADDRESS'"
          ></astral-toggle>
          <h6 class="astral-grid-full">{{ individualAddressMessage | translate }}</h6>
          <div class="astral-grid-full">
            <app-postal-address
              [group]="form.controls['invoiceAddress']"
              [model]="invoiceAddress"
              [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
              [showName]="true"
              [mandatory]="true"
              [title]="''"
            ></app-postal-address>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-textarea class="astral-grid-full" [control]="form.controls['specialTerms']"></astral-textarea>
        </astral-layout-group>
      </div>
      </astral-form>
    </div>
  </ng-template>
</section>
